'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');

/**
 * 숫자를 표시하는 뱃지 컴포넌트
 *
 * @component
 * @param {object} props
 * @param {string | number} props.text - 뱃지에 표시될 텍스트 또는 숫자, 0을 보여줄 때에는 String이어야 함
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {'primary' | 'white_primary' | 'white_gray' | 'gray'} [props.variant='primary'] - 뱃지의 스타일 변형
 * @param {boolean} [props.showZero=false] - 값이 0일 때 뱃지를 표시할지 여부
 *
 * @example
 * // 기본 사용법
 * <CountBadge text="5" />
 *
 * // 0 표시하기
 * <CountBadge text="0" showZero={true} />
 *
 * // 다른 스타일 변형 사용
 * <CountBadge text="10" variant="white_primary" />
 */ const CountBadge = ({ text, className, variant = 'primary', showZero = false })=>{
    var _a;
    const isHiddenBadgeText = !showZero && text == 0 || text === '';
    const badgeNumber = Number(text) > 99 ? '99+' : text;
    const VARIANTS = [
        {
            name: 'primary',
            className: 'text-w-white bg-primary'
        },
        {
            name: 'white_primary',
            className: 'text-primary bg-w-white'
        },
        {
            name: 'white_gray',
            className: 'text-w-gray-600 bg-w-white'
        },
        {
            name: 'gray',
            className: 'text-w-gray-600 bg-w-gray-200'
        }
    ];
    const badgeClasses = {
        baseClass: 'absolute box-border flex min-h-4 w-fit min-w-4 select-none items-center justify-center rounded-full px-1 py-px text-[11px] font-normal tracking-normal leading-none',
        matchedVariantClass: (_a = VARIANTS.find((eachVariant)=>eachVariant.name === variant)) === null || _a === void 0 ? void 0 : _a.className,
        hiddenClass: isHiddenBadgeText && 'hidden'
    };
    return jsxRuntime.jsx("span", {
        "data-testid": "design-system-count-badge",
        className: tailwindMerge.twMerge(badgeClasses.baseClass, badgeClasses.matchedVariantClass, badgeClasses.hiddenClass, className),
        children: badgeNumber
    });
};

module.exports = CountBadge;
